

import { NullLogger } from "@microsoft/signalr";
import { stringify } from "querystring";
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";

import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas';

export interface SignatureCanvasHandle {
    getImage: () => Promise<string>;
}

interface SignatureCanvasProps {
    newImageValue: (image: string) => void;
}



const SignatureCanvas = forwardRef<SignatureCanvasHandle, SignatureCanvasProps>(function SignatureCanvas({newImageValue}, ref) {


    const canvas = useRef<ReactSketchCanvasRef>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);

 
    
 const removeWhiteBackgroundFromBase64 = (
        base64: string,
        tolerance: number = 240
    ): Promise<string> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = base64;


        img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            reject("Canvas not supported");
            return;
        }

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];

            // Remove white pixels
            if (r > tolerance && g > tolerance && b > tolerance) {
            data[i + 3] = 0; // transparent
            }
        }

        ctx.putImageData(imageData, 0, 0);

        resolve(canvas.toDataURL("image/png")); // return transparent PNG
        };

        console.log('img.onerror :: ', img.onerror);

        img.onerror = () => reject("Failed to load base64 image");
    });
    };

    useImperativeHandle(ref, () => ({
        getImage: async () => {
            const data = await canvas.current?.exportImage("png");
            const newImage = data ? await removeWhiteBackgroundFromBase64(data) : null;
            return newImage ?? "";
        }
    }));

    useEffect(() => {
       
    }, []);

    return (
        <div>
            {/* <h1>Signature Canvas</h1> */}
                   <ReactSketchCanvas
                    style={{ border: '0.0625rem solid #9c9c9c',
                             borderRadius: '0.25rem',}}
                    width="1000"
                    height="400"
                    strokeWidth={4}
                    strokeColor="black"
                    ref={canvas}
                    backgroundImage = ""
                    />
        </div>
    );
});



export default SignatureCanvas;